import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
} from '@angular/core';
import {
  PanelStatus,
  POPUP_INSTANCE_TOKEN,
  PopupInstance,
} from '@lbmx/root-services';
import { merge } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Directive({
  selector: '[popupInstance]',
  providers: [
    {
      provide: POPUP_INSTANCE_TOKEN,
      useFactory: (directive: WizardPopupInstanceDirective) =>
        directive.popupInstance,
      deps: [WizardPopupInstanceDirective],
    },
  ],
})
export class WizardPopupInstanceDirective implements AfterViewInit {
  @Input() set popupInstance(instance: PopupInstance) {
    this._instance = instance;
    instance.popupRef = this.el;
    instance.hasScroll = (): boolean =>
      this.el
        ? this.el.nativeElement.parentElement.scrollHeight >
          window.innerHeight * 0.9
        : false;
  }

  get popupInstance() {
    return this._instance;
  }

  private _instance: PopupInstance;

  constructor(private el: ElementRef) {}
  public ngAfterViewInit(): void {
    const panelStatus$ = this._instance.panelStatus$.pipe(
      tap((popupStatus) =>
        this._instance.panelStatuses.next({
          ...this._instance.panelStatuses.value,
          ...popupStatus,
        })
      )
    );

    const panelStatuses$ = this._instance.panelStatuses.pipe(
      map((popupStatuses) =>
        Object.values(popupStatuses).reduce(
          (popupStatus, current) =>
            popupStatus === PanelStatus.OPEN ? PanelStatus.OPEN : current,
          PanelStatus.CLOSED
        )
      ),
      tap((x: PanelStatus) => {
        if (x === PanelStatus.OPEN && !this.popupInstance.hasScroll()) {
          this._instance.overflow = 'visible';
        } else {
          this._instance.overflow = 'scroll';
        }
      })
    );

    merge(panelStatus$, panelStatuses$).subscribe();
  }
}
